module.exports = __webpack_public_path__ + "static/map-66198c4b10f78d53a1e0d18eaba6f82d.jpg";